export default {
	'no-data-to-show': 'لا توجد بيانات لعرضها',
	'material-name': 'اسم المادة',
	'customer-name': 'اسم الزبون',
	'customer-type': 'نوع الزبون',
	date: 'التاريخ',
	price: 'السعر',
	quantity: 'الكمية',
	'payment-method': 'طريقة الدفع',
	unknown: 'غير معروف',
}
